// extracted by mini-css-extract-plugin
export var body = "_kj-0";
export var sectionHeader = "_kj-4";
export var shortcutColumns = "_kj-2";
export var shortcutList = "_kj-1";
export var shortcutSection = "_kj-3";